import React from 'react';
import { Truck, User, Users, ChevronRight, ArrowLeft, Eye } from 'lucide-react';

export const AuthPageShell = ({ children, icon: Icon, iconBg, title, subtitle, onBack, backTestId }) => (
  <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 flex items-center justify-center p-4">
    <div className="w-full max-w-md">
      <div className="text-center mb-6 sm:mb-8">
        <div className={`inline-flex items-center justify-center w-14 h-14 sm:w-16 sm:h-16 ${iconBg || 'bg-emerald-500'} rounded-2xl mb-3 sm:mb-4`}>
          <Icon className="w-7 h-7 sm:w-8 sm:h-8 text-white" />
        </div>
        <h1 className="text-2xl sm:text-3xl font-bold text-white">{title}</h1>
        <p className="text-slate-400 mt-1 sm:mt-2 text-sm sm:text-base">{subtitle}</p>
      </div>

      <div className="bg-slate-800/50 backdrop-blur-xl rounded-2xl p-5 sm:p-8 border border-slate-700">
        {onBack && (
          <button
            onClick={onBack}
            className="flex items-center gap-2 text-slate-400 hover:text-white mb-4 transition"
            data-testid={backTestId}
          >
            <ArrowLeft className="w-4 h-4" />
            <span className="text-sm">Back</span>
          </button>
        )}
        {children}
      </div>
    </div>
  </div>
);

export const ChoiceScreen = ({ onSelectMode }) => (
  <AuthPageShell icon={Truck} iconBg="bg-emerald-500" title="LAWD" subtitle="Local Australian Work Diary">
    <h2 className="text-lg font-bold text-white text-center mb-6">How will you use LAWD?</h2>
    
    <div className="space-y-3">
      {/* Owner/Driver Option */}
      <button
        onClick={() => onSelectMode('register-driver')}
        className="w-full p-4 bg-slate-700/50 hover:bg-slate-700 border border-slate-600 hover:border-emerald-500 rounded-xl transition group text-left"
        data-testid="choice-driver"
      >
        <div className="flex items-center gap-4">
          <div className="w-12 h-12 bg-emerald-500/20 rounded-xl flex items-center justify-center group-hover:bg-emerald-500/30 transition">
            <User className="w-6 h-6 text-emerald-500" />
          </div>
          <div className="flex-1">
            <div className="font-bold text-white">Owner/Driver</div>
            <div className="text-sm text-slate-400">Solo operator with one vehicle</div>
            <div className="text-xs text-emerald-500 mt-1">$15/month</div>
          </div>
          <ChevronRight className="w-5 h-5 text-slate-500 group-hover:text-emerald-500 transition" />
        </div>
      </button>

      {/* Business/Fleet Option */}
      <button
        onClick={() => onSelectMode('register-business')}
        className="w-full p-4 bg-slate-700/50 hover:bg-slate-700 border border-slate-600 hover:border-blue-500 rounded-xl transition group text-left"
        data-testid="choice-business"
      >
        <div className="flex items-center gap-4">
          <div className="w-12 h-12 bg-blue-500/20 rounded-xl flex items-center justify-center group-hover:bg-blue-500/30 transition">
            <Users className="w-6 h-6 text-blue-500" />
          </div>
          <div className="flex-1">
            <div className="font-bold text-white">Business / Fleet</div>
            <div className="text-sm text-slate-400">Multiple drivers and vehicles</div>
            <div className="text-xs text-blue-500 mt-1">$20/driver/month</div>
          </div>
          <ChevronRight className="w-5 h-5 text-slate-500 group-hover:text-blue-500 transition" />
        </div>
      </button>

      {/* Group View Option */}
      <button
        onClick={() => onSelectMode('register-group-view')}
        className="w-full p-4 bg-slate-700/50 hover:bg-slate-700 border border-slate-600 hover:border-violet-500 rounded-xl transition group text-left"
        data-testid="choice-group-view"
      >
        <div className="flex items-center gap-4">
          <div className="w-12 h-12 bg-violet-500/20 rounded-xl flex items-center justify-center group-hover:bg-violet-500/30 transition">
            <Eye className="w-6 h-6 text-violet-500" />
          </div>
          <div className="flex-1">
            <div className="font-bold text-white">Group View</div>
            <div className="text-sm text-slate-400">View consented drivers across fleets</div>
            <div className="text-xs text-violet-500 mt-1">Contact for pricing</div>
          </div>
          <ChevronRight className="w-5 h-5 text-slate-500 group-hover:text-violet-500 transition" />
        </div>
      </button>
    </div>

    <div className="mt-6 pt-6 border-t border-slate-700">
      <button
        onClick={() => onSelectMode('login')}
        className="w-full py-3 bg-slate-700 hover:bg-slate-600 text-white rounded-xl font-medium transition"
        data-testid="choice-login"
      >
        Already have an account? Sign In
      </button>
    </div>
  </AuthPageShell>
);
